
import { useState, useEffect } from 'react';

export function useSubdomain() {
  const [subdomainInfo, setSubdomainInfo] = useState({
    subdomain: import.meta.env.VITE_SUBDOMAIN_NAME || 'template',
    title: 'Therize Community',
    theme: {
      primary: '#64ffda',
      secondary: '#0a192f',
      accent: '#8892b0',
      background: '#0a192f'
    }
  });

  useEffect(() => {
    // Extract subdomain from hostname
    const extractSubdomain = () => {
      const hostname = window.location.hostname;
      
      // For localhost development
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return import.meta.env.VITE_SUBDOMAIN_NAME || 'template';
      }
      
      // For production
      const parts = hostname.split('.');
      if (parts.length > 2 && parts[0] !== 'www') {
        return parts[0];
      }
      
      return 'main';
    };

    const subdomain = extractSubdomain();
    
    // In a real implementation, you would fetch the subdomain configuration
    // from an API or configuration service
    const fetchSubdomainConfig = async () => {
      try {
        // This is a placeholder for the actual API call
        // const response = await fetch(`/api/subdomains/${subdomain}`);
        // const data = await response.json();
        
        // For now, we'll just set some default values based on the subdomain
        setSubdomainInfo({
          subdomain,
          title: `${subdomain.charAt(0).toUpperCase() + subdomain.slice(1)} Community`,
          theme: {
            primary: '#64ffda',
            secondary: '#0a192f',
            accent: '#8892b0',
            background: '#0a192f'
          }
        });
      } catch (error) {
        console.error('Error fetching subdomain configuration:', error);
      }
    };

    fetchSubdomainConfig();
  }, []);

  return subdomainInfo;
}
